import { Trash2, ExternalLink, CloudOff, CloudCheck } from "lucide-react";
import { FEEDBACK_TYPE_META } from "./shared/constants";
import { formatDate, truncateUrl } from "./shared/format";
import { LoadingRow, EmptyState } from "./shared/ui";

export function FeedbackTab({ feedback, loadingFeedback, handleDeleteFeedback }) {
  return (
    <>
          <div className="flex items-center justify-between mb-4">
            <div className="font-mono text-[10px] tracking-[0.3em] text-tw-muted">FEEDBACK STROOM</div>
            <div className="font-mono text-sm text-tw-yellow" data-testid="admin-feedback-count">
              {feedback.length}
            </div>
          </div>

          {loadingFeedback ? (
            <LoadingRow />
          ) : feedback.length === 0 ? (
            <EmptyState label="Nog geen feedback" hint="Feedback van het team verschijnt hier." testId="admin-feedback-empty" />
          ) : (
            <div className="space-y-2" data-testid="admin-feedback-list">
              {feedback.map((f, i) => {
                const meta = FEEDBACK_TYPE_META[f.type] || FEEDBACK_TYPE_META.Feedback;
                const { Icon, color } = meta;
                return (
                  <article
                    key={f.id}
                    className="tw-fadeup bg-tw-surface border border-tw p-5 hover:border-tw-yellow transition-colors duration-150"
                    style={{ animationDelay: `${Math.min(i * 30, 400)}ms` }}
                    data-testid={`admin-feedback-${f.id}`}
                  >
                    <header className="flex flex-wrap items-center justify-between gap-3 mb-3">
                      <div className="flex items-center gap-3 flex-wrap">
                        <span
                          className="inline-flex items-center gap-1.5 px-2 py-1 text-[10px] font-bold uppercase tracking-[0.2em] text-black"
                          style={{ backgroundColor: color }}
                        >
                          <Icon size={11} strokeWidth={2.8} />
                          {f.type}
                        </span>
                        <span className="text-white text-sm font-medium">{f.user_name}</span>
                        <span className="font-mono text-[11px] text-tw-muted">{f.user_email}</span>
                        <span className="font-mono text-[11px] text-tw-muted">· {formatDate(f.submitted_at)}</span>
                      </div>
                      <div className="flex items-center gap-2" title={f.forwarded ? "Doorgestuurd naar Feedback Hub" : "Alleen lokaal — externe hub onbereikbaar"}>
                        {f.forwarded ? (
                          <span className="flex items-center gap-1 text-[10px] uppercase tracking-widest text-[#32D74B]">
                            <CloudCheck size={12} strokeWidth={2.5} /> Doorgestuurd
                          </span>
                        ) : (
                          <span className="flex items-center gap-1 text-[10px] uppercase tracking-widest text-tw-red">
                            <CloudOff size={12} strokeWidth={2.5} /> Lokaal
                          </span>
                        )}
                        <button
                          type="button"
                          onClick={() => handleDeleteFeedback(f.id)}
                          data-testid={`admin-feedback-delete-${f.id}`}
                          title="Verwijder feedback"
                          aria-label="Verwijder feedback"
                          className="text-tw-muted hover:text-tw-red transition-colors p-1"
                        >
                          <Trash2 size={13} strokeWidth={2.5} />
                        </button>
                      </div>
                    </header>
                    <p className="text-white leading-relaxed whitespace-pre-wrap">{f.message}</p>
                    {f.page_url && (
                      <a
                        href={f.page_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mt-3 inline-flex items-center gap-1 font-mono text-[10px] tracking-widest uppercase text-tw-muted hover:text-tw-yellow transition-colors"
                      >
                        <ExternalLink size={11} /> {truncateUrl(f.page_url)}
                      </a>
                    )}
                    {f.forward_error && (
                      <div className="mt-3 font-mono text-[10px] text-tw-red/80 border-t border-tw pt-2">
                        Doorstuurfout: {f.forward_error}
                      </div>
                    )}
                  </article>
                );
              })}
            </div>
          )}
    </>
  );
}
